import React from 'react';
import BaseComponent from '../../../baseClasses/BaseComponent';
import animator from '../../../helpers/animator';
import TaskActivityCard from './TaskActivityCard';
import './TaskActivity.scss';

export default class TaskActivity extends BaseComponent {

  constructor(props) {
    super(props);
    this.animator = new animator();

    this.getFormattedEventHistoryObject = this.getFormattedEventHistoryObject.bind(this);
  }

  componentDidMount() {
    const activity = this.createTaskActivityList();
    this.setState({ activity });
  }

  componentDidUpdate(prevProps){
    if (prevProps.task != this.props.task) {
      const activity = this.createTaskActivityList();
      this.setState({ activity });
    }
  }

  handleAssignmentMessage(type){
    let message;
    switch(type){
    case 'field_user':
      message = 'Was assigned to this task as a field user.';
      break;
    case 'reviewer':
      message = 'Was assigned to this task as a reviewer.';
      break;
    case 'approver':
      message = 'Was assigned to this task as an approver.';
      break;
    case 'notify':
      message = 'Was added as a user to be notified.';
      break;
    default:
      break;
    }
    return message;
  }

  handleGetUser(userAssignments, type){
    let user;
    if (userAssignments){
      for (let assignment of userAssignments){
        if (assignment.assignment_type == type){
          user = assignment.user;
        }
      }
    }
    return user;
  }

  getFormattedEventHistoryObject(userAssignments, event){
    let item = {};
    const type = event.activity.name;
    switch (type) {
    case 'Completion Step is Completed':
    case 'Status Changed':
      item.caption = 'Task Event';
      item.user = event.user_who_performed_action;
      break;
    case 'task_complete':
      item.caption = 'Task Completed';
      item.user = this.handleGetUser(userAssignments, 'approver');
      break;
    case 'task_pending_review':
      item.caption = 'Work Submitted';
      item.user = this.handleGetUser(userAssignments, 'field_user');
      break;
    case 'task_pending_approval':
      item.caption = 'Task Reviewed';
      item.user = this.handleGetUser(userAssignments, 'reviewer');        
      break;
    case 'review_rejected':
      item.caption = 'Rejected';  
      item.user = this.handleGetUser(userAssignments, 'reviewer');
      break;
    case 'approval_rejected':
      item.caption = 'Rejected';  
      item.user = this.handleGetUser(userAssignments, 'approver');
      break;
        
    default:
      item.caption = type;
      break;
    }
    if (item && !item.user) {
      item.user = event.user_who_performed_action;
      if (!item.user) {
        item.user = {
          id: -1, first_name: 'None', last_name: 'Specified',
        };
      }

    }
    return item;
  }

  createTaskActivityList() {
    const { task } = this.props;
    let completeList = [];
    if (task.comments) {
      for (let comment of task.comments){
        let item = {};
        item.user = comment.user;
        item.date = comment.created_at;
        item.caption = comment.caption;
        item.message = comment.body;
        completeList.push(item);
      }
    }
    if (task.event_histories) {
      for (let history of task.event_histories) {
        if (history.event_type != 'administrative' && history.activity) {
          let item = {};
          const formattedObject = this.getFormattedEventHistoryObject(task.user_task_assignments, history);
          if (!formattedObject) {
            item = null;
          }
          else {
            item.user = formattedObject.user;
            item.caption = formattedObject.caption;
            item.message = history.body;
            item.date = history.created_at;
          }
          if (item) {
            completeList.push(item);
          }
        }
      }
    }
    if (task.completion_criteria) {
      for (let completionStep of task.completion_criteria){
        if (completionStep.event_histories) {
          for (let ccHistory of completionStep.event_histories) {
            if (ccHistory.activity) {
              let caption = this.getFormattedEventHistoryObject(task.user_task_assignments, ccHistory);
              if (caption) {
                let item = {};
                item.user = caption.user;
                item.date = ccHistory.created_at;
                item.caption = caption.caption;
                item.message = ccHistory.body;
                completeList.push(item);
              }
            }
          }
        }
        if (completionStep.comments) {
          for (let comment of completionStep.comments) {
            let item = {};
            item.user = comment.user;
            item.date = comment.created_at;
            item.caption = comment.caption;
            item.message = comment.body;
            completeList.push(item);
          }
        }
      }
    }
    if (task.user_task_assignments) {
      for (let assignment of task.user_task_assignments) {
        // Field user events have moved to activity logs
        // if (assignment.assignment_type != 'field_user') {
        let user = assignment.user;
        let item = {};
        item.user = user;
        item.date = assignment.created_at;
        item.caption = 'Task Assignment';
        item.message = this.handleAssignmentMessage(assignment.assignment_type);
        completeList.push(item);
        // }
      }
    }

    completeList.sort((a, b) => {
      if (a.date < b.date) {
        return 1;
      }
      else if (a.date > b.date) {
        return -1;
      }
      else return 0;
    });

    let activityList = null;
    activityList = completeList.map((item, index) => {
      return <TaskActivityCard key={'comment-' + index} user={item.user}
        date={item.date} caption={item.caption} message={item.message} />;
    });
      
    return <div className="task-activity-list">
      {activityList}
    </div>;
  }

  render() {

    return (

      // Replace with the appropriate HTML
      <div className="activity-list">
        {this.state.activity}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TaskCRUD/TaskActivity/index.js